import { Button } from '@/components';
import { CreateBusinessAreaUserModal } from '@/modules/Users/pages/UsersPage/components/CreateBusinessAreaUserModal/CreateBusinessAreaUserModal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type BusinessAreaEmployeesTabActionsProps = {
  businessAreaId: number;
};

export const BusinessAreaEmployeesTabActions = ({
  businessAreaId,
}: BusinessAreaEmployeesTabActionsProps) => {
  const { t } = useTranslation();
  const [
    isCreateBusinessAreaUserModalOpen,
    setIsCreateBusinessAreaUserModalOpen,
  ] = useState(false);
  return (
    <>
      <Button
        onClick={() => setIsCreateBusinessAreaUserModalOpen(true)}
        variant="primary"
      >
        {t('add')}
      </Button>
      <CreateBusinessAreaUserModal
        isOpen={isCreateBusinessAreaUserModalOpen}
        businessAreaId={businessAreaId}
        onClose={() => setIsCreateBusinessAreaUserModalOpen(false)}
      />
    </>
  );
};
